import { el } from '../core/dom.js';
import { withProduct } from '../core/route-map.js';
import { card } from '../components/card.js';
import { button } from '../components/button.js';
import { errorPanel } from '../components/error.js';

/**
 * Fallback for an unfinished or unknown screen: the shell stays, the page says so.
 * @param {object} view
 * @param {{ productId?: string }} opts
 */
export function renderScreen(view, opts) {
  const productId = (opts && opts.productId) || '';
  const home = withProduct('/app/dashboard', productId);
  if (view.missing) {
    return errorPanel({
      title: 'Page not found',
      message: 'That address is not part of Bonnie yet.',
      action: button('Back to dashboard', { href: home, variant: 'primary' }),
    });
  }
  if (view.denied) {
    return errorPanel({
      title: view.title || 'Not available',
      message: 'Only the BonnieOS super admin can open this screen.',
      action: button('Back to dashboard', { href: home, variant: 'primary' }),
    });
  }
  return el('div', { class: 'soon' }, card({
    kicker: 'Coming soon',
    title: view.title || 'Bonnie',
    body: el('p', { class: 'soon-copy' }, 'This screen is coming soon.'),
    footer: button('Back to dashboard', { variant: 'primary', href: home }),
  }));
}
